/* eslint-disable no-unused-vars */
import { assign } from "xstate";
import { isNumber } from "lodash";
import {
  ANIMATION_EVENTS,
  ASSET_TYPES,
  PAGES,
  XR_MODES,
  AR_PLATFORM,
} from "../constants";
import {
  getPepperfryTemplate,
  pepperfryButtonConfigs,
  topLevelButtonPresets,
} from "../engineTemplates/pepperfryTemplate";
import { setInteractivePage, applyTexture } from "../modules/EngineUtils";
import { generateUIConfig } from "../modules/MachineHelper";
// import { generateUIConfig } from "../modules/MachineHelper";
import {
  checkAssetsLoaded,
  createScene,
  // downloadAssets,
  downloaderSequence,
  executeInSequence,
  getClientIdFromURL,
  getOnLoadtexturesIfAny,
  getParamsFromURL,
  getCorrelationData,
} from "../modules/MachineUtils";

import WaitSM from "./WaitSM";

export const ENGINE_SM_CONST = {
  INITIAL: "INITIAL",
  READY: "READY",
  CONFIG_BUILDER: "CONFIG_BUILDER",
  SETUP_SCENE: "SETUP_SCENE",
  ON_LOAD_ANIMATION: "ON_LOAD_ANIMATION",
  ON_LOAD_ASSET_DOWNLOAD: "ON_LOAD_ASSET_DOWNLOAD",
};

export const ENGINE_SM = (actions, skuId) => ({
  initial: ENGINE_SM_CONST.INITIAL,
  states: {
    [ENGINE_SM_CONST.INITIAL]: {
      entry: [
        assign({
          skuId,
          clientId: getClientIdFromURL(actions),
          preprod: getParamsFromURL(actions.window, "preprod"),
          mode: getParamsFromURL(actions.window, "mode"),
          modelId: "abc",
        }),
        () => actions.RendererState().setPage(PAGES.LOADING),
        (context) => executeInSequence(downloaderSequence(actions, context)),
      ],
      ...WaitSM(
        checkAssetsLoaded(actions, skuId, [
          ASSET_TYPES.GLTF,
          ASSET_TYPES.HDRI,
          ASSET_TYPES.CUBE_MAP,
        ])
      ),
      onDone: { target: ENGINE_SM_CONST.CONFIG_BUILDER },
    },
    [ENGINE_SM_CONST.CONFIG_BUILDER]: {
      entry: [
        () =>
          actions.ConfigBuilder.setConfig(
            skuId,
            actions.ConfigLoader.getSKUConfig(skuId)
          ),
        () => actions.Event.sendSMEvent("CONFIG_BUILT"),
      ],
      on: { CONFIG_BUILT: ENGINE_SM_CONST.SETUP_SCENE },
    },

    [ENGINE_SM_CONST.SETUP_SCENE]: {
      entry: [
        () => console.log("engine ready state"),
        () => actions.RendererState().setPage(PAGES.XR),
        () => createScene(actions, skuId, actions.ConfigBuilder),
        (context) => {
          const skuConfig = actions.ConfigBuilder.getSKUConfig(skuId);
          const templateConfig = getPepperfryTemplate(context, actions);
          const envConfig = templateConfig.getConfigByPlatform(
            skuConfig.environmentLight
          );
          const modelHashId = skuConfig.models.path;
          const assetObject = actions.AssetLoader.getAsset(modelHashId);
          const clonedObject = actions.ARModels.cloneandAddModel(
            assetObject,
            context.modelId
          );
          clonedObject.name = context.modelId;
          actions.ThreejsScene.addModelToScene(
            context.modelId,
            clonedObject,
            skuConfig.models.config.scale
          );
          if (isNumber(envConfig?.exposure)) {
            actions.ARModels.updateEnvMapIntensity(
              context.modelId,
              envConfig?.exposure
            );
          }
          actions.ThreejsScene.addHelpers();
          actions.ThreejsScene.centerAndScale(
            clonedObject,
            skuConfig.models?.boxSize
          );
        },
        () => actions.RendererState().setPage(PAGES.XR),
        (context) => {
          const templateConfig = getPepperfryTemplate(context, actions);
          console.log("templateConfig", templateConfig, context);
          actions.ConfiguratorState().setConfiguratorUI(templateConfig);
        },
        () =>
          actions.ThreejsScene.setCameraController(
            actions.ConfigLoader.getSKUConfig(skuId).orbitControls
          ),
        () => actions.Event.sendSMEvent("SCENE_READY"),
      ],
      on: {
        SCENE_READY: [
          {
            target: ENGINE_SM_CONST.READY,
            cond: (context) => {
              const templateConfig = getPepperfryTemplate(context, actions);
              const onLoadConfig = templateConfig.getConfigByPlatform(
                templateConfig.getOnLoadConfig()
              );
              return !onLoadConfig;
            },
          },
          {
            target: ENGINE_SM_CONST.ON_LOAD_ASSET_DOWNLOAD,
            cond: (context) => {
              const templateConfig = getPepperfryTemplate(context, actions);
              const onLoadConfig = templateConfig.getConfigByPlatform(
                templateConfig.getOnLoadConfig()
              );
              // console.log("🚀 ~ file: EngineSM.js ~ line 139 ~ onLoadConfig", onLoadConfig)
              return !!onLoadConfig;
            },
          },
        ],
      },
    },
    [ENGINE_SM_CONST.ON_LOAD_ASSET_DOWNLOAD]: {
      entry: [
        () => {
          console.log("waiting for onload textures to be downloaded");
        },
      ],
      ...WaitSM(getOnLoadtexturesIfAny(actions, skuId)),
      onDone: ENGINE_SM_CONST.ON_LOAD_ANIMATION,
    },
    [ENGINE_SM_CONST.ON_LOAD_ANIMATION]: {
      entry: [
        // eslint-disable-next-line no-unused-vars
        (context) => {
          // eslint-disable-next-line no-unused-vars
          const buttonsConfig = generateUIConfig(
            context.modelId,
            actions,
            actions.ConfigLoader.getSKUConfig(skuId),
            XR_MODES.XR,
            AR_PLATFORM.THREEJS,
            "ENGINE"
          );
          if (buttonsConfig?.onLoad) {
            buttonsConfig.onLoad();
          }
          actions.Event.sendSMEvent(ANIMATION_EVENTS.ANIMATION_QUEUE_COMPLETE);
        },
      ],
      on: {
        [ANIMATION_EVENTS.ANIMATION_QUEUE_COMPLETE]: ENGINE_SM_CONST.READY,
      },
    },
    [ENGINE_SM_CONST.READY]: {
      entry: [
        () => {
          console.log("removing helpers");
          actions.ThreejsScene.removeHelpers();
        },
        () =>
          actions.ThreejsScene.setCameraController(
            actions.ConfigBuilder.getSKUConfig(skuId).orbitControls
          ),
        () => console.log("engine ready state"),
        (context) => {
          // eslint-disable-next-line no-unused-vars
          const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
          const buttonsConfig = generateUIConfig(
            context.modelId,
            actions,
            skuConfig,
            XR_MODES.XR,
            AR_PLATFORM.THREEJS,
            "ENGINE"
          );
          // Default Material Color After load
          // const materialConfig = buttonsConfig.menu.find(
          //   (menuItem) => menuItem.name === "colorChangeIcon"
          // );
          // let defaultMaterialColor = null;
          // if (materialConfig) {
          //   defaultMaterialColor = materialConfig.menu.find(
          //     (menuItem) => menuItem.default === 1
          //   );
          //   if (!defaultMaterialColor) {
          //     [defaultMaterialColor] = materialConfig.menu;
          //   }
          //   defaultMaterialColor.onClick();
          // }

          buttonsConfig.setInteractivePage = setInteractivePage(
            actions,
            context,
            pepperfryButtonConfigs,
            topLevelButtonPresets
          );
          console.log("innn");
          console.log("generating uiCOnfig", buttonsConfig, context);
          actions.useEngineStore.getState().setEngineLoadingState(false);
          actions.useSubmenuStore
            .getState()
            .setCorrelationFlag(skuConfig?.iconCorrelationV2 ?? false);
          actions.useSubmenuStore
            .getState()
            .setCorrelationConfig(getCorrelationData(buttonsConfig));
          actions.useSubmenuStore.getState().setButtonsConfig(buttonsConfig);
          actions.useButtonConfigStore
            .getState()
            .setUIConfig({ submenu: true });
        },
        // (context) => {
        //   const templateConfig = getPepperfryTemplate(context.skuId, actions);
        //   console.log(
        //     "templateConfig.components[0].components[1].getSceneChildrens()",
        //     templateConfig.components[0].components[1].getSceneChildrens()
        //   );
        //   const a = "#ffffff";
        //   actions.ThreejsScene.updateAmbientLight({
        //     intensity: 1,
        //     color: parseInt(a.slice(1), 16),
        //   });
        // },
      ],
    },
  },
});
